import * as React from 'react';
import { IgcColumnComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcColumnComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * **Ignite UI for Angular Column** -  [Documentation](https://www.infragistics.com/products/ignite-ui-angular/angular/components/grid/grid#columns-configuration)  The Ignite UI Column is used within an `igx-grid` element to define what data the column will show. Features such as sorting,  filtering & editing are enabled at the column level.  You can also provide a template containing custom content inside  the column using `ng-template` which will be used for all cells within the column.
 * @fires hiddenChange - Emitted when the column is hidden or shown.
 * @fires expandedChange - Emitted when the column expanded or collapsed.
 * @fires widthChange - Emitted when the column width changes.
 * @fires pinnedChange - Emitted when the column is pinned/unpinned.
 * @class
 */
export const IgrColumn = /* @__PURE__ */ createComponent({
  tagName: 'igc-column',
  displayName: 'IgrColumn',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onHiddenChange: 'hiddenChange' as EventName<
      IgcColumnComponentEventMap['hiddenChange']
    >,
    onExpandedChange: 'expandedChange' as EventName<
      IgcColumnComponentEventMap['expandedChange']
    >,
    onWidthChange: 'widthChange' as EventName<
      IgcColumnComponentEventMap['widthChange']
    >,
    onPinnedChange: 'pinnedChange' as EventName<
      IgcColumnComponentEventMap['pinnedChange']
    >,
  },
  renderProps: {
    summaryTemplate: 'summaryTemplate',
    bodyTemplate: 'bodyTemplate',
    headerTemplate: 'headerTemplate',
    inlineEditorTemplate: 'inlineEditorTemplate',
    errorTemplate: 'errorTemplate',
    filterCellTemplate: 'filterCellTemplate',
  },
});

export type IgrColumn = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrColumnModule = Component;
